module.exports = __webpack_public_path__ + "static/media/clock-blue.dddddcf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/clock-blue.svg
// module id = 753
// module chunks = 0